import { textSettingsAtom } from 'atoms'
import { useAtom } from 'jotai'
import { Typography, Box, Switch, FormControlLabel } from '@mui/material'
import { textPositionImages } from 'constants'
import ImageListSelector from 'components/ImageListSelector'
import FontFamilySelector from 'components/FontFamilySelector'
import Circle from '@uiw/react-color-circle'
import { useTranslation } from 'react-i18next'
import { useTheme } from '@mui/material/styles'

const colors = [
  '#F44E3B', // Red
  '#FE9200', // Orange
  '#FCDC00', // Yellow
  '#DBDF00', // Lime
  '#A4DD00', // Green
  '#68CCCA', // Cyan
  '#73D8FF', // Sky Blue
  '#AEA1FF', // Light Purple
  '#FDA1FF', // Pink
  '#333333', // Black
  '#808080', // Gray
  '#B3B3B3', // Light Gray
  '#FFFFFF', // White
  '#4D4D4D', // Dark Gray
  '#FF8A65', // Coral
  '#BA68C8', // Lavender
  '#90CAF9', // Light Blue
  '#4CAF50', // Medium Green
]

const SectionHeader = ({ children }) => {
  const theme = useTheme()
  return (
    <Typography
      variant="h4"
      sx={{
        color: theme.palette.primary.main,
        textAlign: 'left',
        pt: 1,
        mb: 1,
      }}
    >
      {children}
    </Typography>
  )
}

const TextSettings = () => {
  const [textSettings, setTextSettings] = useAtom(textSettingsAtom)
  const { t } = useTranslation()

  const updateTextSettings = (key, value) => {
    setTextSettings({ ...textSettings, [key]: value })
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: 2, // Space between items
        justifyContent: 'space-between', // Distribute items evenly
      }}
    >
      <Box sx={{ flex: '1 1 auto', minWidth: '200px' }}>
        <SectionHeader>{t('visibilityPosition')}</SectionHeader>
        <ImageListSelector
          images={textPositionImages}
          onClick={(value) => updateTextSettings('position', value)}
          value={textSettings.position}
        />
      </Box>

      <Box sx={{ flex: '1 1 auto', minWidth: '200px' }}>
        <SectionHeader>{t('font')}</SectionHeader>
        <FontFamilySelector
          onClick={(value) => updateTextSettings('font', value)}
          value={textSettings.font}
        />
      </Box>
      <Box sx={{ flex: '1 1 auto', minWidth: '200px' }}>
        <SectionHeader>{t('capitalLetters')}</SectionHeader>
        <FormControlLabel
          control={
            <Switch
              checked={Boolean(textSettings.capitalLetters)}
              onChange={(e) =>
                updateTextSettings('capitalLetters', e.target.checked)
              }
              color="primary"
            />
          }
          label={t('showTextInCapitalLetters')}
        />
      </Box>
      <Box
        sx={{
          flex: '1 1 auto',
          maxWidth: '319px',
        }}
      >
        <SectionHeader>{t('color')}</SectionHeader>
        <div
          style={{
            backgroundColor: '#F0F0F0',
            padding: '10px',
            borderRadius: '8px',
            border: `1px solid ${textSettings.color}`,
          }}
        >
          <Circle
            colors={colors}
            color={textSettings.color}
            onChange={(color) => updateTextSettings('color', color.hex)}
          />
        </div>
      </Box>
    </Box>
  )
}

export default TextSettings
